module.exports = {};



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/_iterators.js
// module id = 55
// module chunks = 99